import React, { useRef, useEffect } from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

// força alta resolução em todos os gráficos
ChartJS.defaults.devicePixelRatio = 2; // pode testar 3 se quiser ainda mais

function hexToRgba(hex, alpha = 1) {
  let r = 0, g = 0, b = 0;
  if (hex.length === 7) {
    r = parseInt(hex.slice(1, 3), 16);
    g = parseInt(hex.slice(3, 5), 16);
    b = parseInt(hex.slice(5, 7), 16);
  }
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

function PieGraph(props) {
  const chartRef = useRef();
  const { data: chartData, onImageReady, onLegendClick, onOldValue, currentValue, oldValue, text } = props;

useEffect(() => {
  setTimeout(() => {
    if (chartRef.current && onImageReady) {
      const canvas = chartRef.current.canvas || chartRef.current.ctx?.canvas;

      if (canvas) {
        const imgBase64 = canvas.toDataURL("image/png");
        onImageReady(imgBase64);
      }
    }
  }, 2000);
}, [chartData, onImageReady]);

  const handleLegendClick = (e, legendItem) => {
    const index = legendItem.index;
    const chart = chartRef.current;
    if (!chart) return;

    if (onLegendClick) {
      const label = chart.data.labels?.[index];
      if (label === currentValue) {
        onLegendClick(null);
      } else {
        onLegendClick(label);
      }
      onOldValue(currentValue);
    }

    chart.update();
  };

  const handleSegmentClick = (event, elements) => {
    if (elements.length > 0) {
      const chart = chartRef.current;
      const index = elements[0].index;
      const label = chartData.labels[index];

      if (!chart) return;

      if (onLegendClick) {
        if (label === currentValue) {
          onLegendClick(null);
        } else {
          onLegendClick(label);
        }
        onOldValue(currentValue);
      }

      chart.update();
    }
  };

  const options = {
    cutout: "50%",
    responsive: true,
    onClick: handleSegmentClick,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: true,
        text: text,
        font: { size: 14 },
        color: "#333",
        padding: { top: 0, bottom: 20 },
      },
      legend: {
        position: "right",
        labels: {
          color: "#333",
          usePointStyle: true,
          pointStyle: "circle",
          font: { size: 10 },
        },
        onClick: handleLegendClick,
      },
      tooltip: {
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        bodyColor: "#fff",
      },
      datalabels: {
        color: "#333",
        font: { weight: "bold", size: 9 },
        formatter: (value, context) => {
          const total = context.dataset.data.reduce((acc, val) => acc + val, 0);
          const percentage = ((value / total) * 100).toFixed(2) + "%";
          return percentage;
        },
        anchor: "end",
        align: "end",
        offset: 2,
      },
    },
  };

  const data = JSON.parse(JSON.stringify(chartData));

  if (currentValue) {
    if ((!oldValue || oldValue !== currentValue) && data && data.labels && data.datasets && data.datasets[0]) {
      const index = data.labels.indexOf(currentValue);
      const rawColors = data.datasets[0].backgroundColor || [];

      const rgbaColors = rawColors.map((color) => (color.startsWith("#") ? hexToRgba(color, 1) : color));

      data.datasets[0].backgroundColor = rgbaColors.map((color, i) => {
        if (index === null || i === index) {
          return color;
        }

        const rgb = color.match(/\d+/g).slice(0, 3);
        return `rgba(${rgb.join(", ")}, 0.2)`;
      });
    }
  }

  return <Pie ref={chartRef} data={data} options={options} plugins={[ChartDataLabels]} />;
}

export default PieGraph;
